import { fromJS, Map } from 'immutable';
import {
    GET_SURVEY,
    GET_SURVEY_FAIL,
    UPDATE_SURVEY,
    GET_SURVEY_RESULT
} from '../constants/actionTypes';

const init = Map({});

export default function surveyReducer(state = init, action) {
    switch (action.type) {
    case GET_SURVEY:
        return action.surveys;
    case GET_SURVEY_FAIL:
        return fromJS(action.errorData);
    case UPDATE_SURVEY:
        return action.surveyUpdated;
    case GET_SURVEY_RESULT:
        return action.result;
    default:
        return state;
    }
}
